import { Button, Col, Modal, Row, Typography } from 'antd';
import BreadcrumbList from '../../Stock/components/Breadcrumb';
import { ViewerBox } from '@root/modules/Busk/Forwarding-Content/components/ViewerBox';
import { DownloadIcon } from '@root/core/components/Icon';
import confirm from 'antd/lib/modal/confirm';
import { CloseOutlined, PaperClipOutlined } from '@ant-design/icons';
import { useEffect, useState, useRef } from 'react';
import { Editor } from '@toast-ui/react-editor';
import { useParams } from 'react-router';
import forwardingService from '../../Message/services/forwarding';

interface MessageDetail {
  quotation: any;
  cancelStatus: string;
  forwarding: {
    name: string;
  };
  seller: {
    companyName: string;
  };
  status: string;
  postDialogs: {
    id: number;
    canEdit: boolean;
    writerType: string;
    writerName: string;
    content: string;
    created_at: string;
  }[];
}

type StatusType =
  | 'Inprogress'
  | 'ShippingProposal'
  | 'ShippingConfirm'
  | 'Complete'
  | 'Cancel'
  | 'ShippingArrival';

const MessageInfo = () => {
  const [list, setList] = useState<MessageDetail>();
  const { id } = useParams<{ id: string }>();
  const fetchData = async () => {
    const res = await forwardingService.getMessageDetail(Number(id));
    setList(res);
  };

  const statusMsg: Record<StatusType, string> = {
    Inprogress: '협의 중',
    ShippingProposal: '선적 시작 수락',
    ShippingConfirm: '선적 시작',
    Complete: '진행 완료',
    ShippingArrival: '선적 도착',
    Cancel: '취소됨 '
  };

  const renderCancelBtn = () => {
    switch (list?.cancelStatus) {
      case 'SellerCancel':
        return (
          <Button
            onClick={async () => {
              await forwardingService.updateStatus(Number(id), {
                cancelStatus: 'None'
              });
              fetchData();
            }}
            className="btn-style"
            style={{ backgroundColor: '#D98282', color: 'white' }}
          >
            대화 종료 요청 취소
          </Button>
        );
      case 'ForwardingCancel':
        return (
          <Button
            onClick={async () => {
              await forwardingService.updateStatus(Number(id), {
                cancelStatus: 'CancelComplete'
              });
              fetchData();
            }}
            className="btn-style"
            style={{ backgroundColor: '#D98282', color: 'white' }}
          >
            대화 종료 요청 수락
          </Button>
        );
      case 'None':
        return (
          <Button
            onClick={onClose}
            className="btn-style"
            style={{ backgroundColor: '#D98282', color: 'white' }}
          >
            대화 종료
          </Button>
        );
      default:
        return null;
    }
  };

  const renderProgressBtn = () => {
    switch (list?.status) {
      case 'ShippingProposal':
        return (
          <Button
            onClick={onAccept}
            className="btn-style"
            style={{ backgroundColor: '#629C53', color: 'white' }}
          >
            선적 시작 수락
          </Button>
        );
      case 'ShippingArrival':
        return (
          <Button
            onClick={onFinish}
            className="btn-style"
            style={{ backgroundColor: '#629C53', color: 'white' }}
          >
            진행 완료
          </Button>
        );
      case 'Complete':
        return (
          <Button
            onClick={onCancel}
            className="btn-style"
            style={{ backgroundColor: '#629C53', color: 'white' }}
          >
            진행 완료 철회
          </Button>
        );
      default:
        return null;
    }
  };

  const onUpdate = async () => {
    try {
      if (mode === 'edit' && list?.postDialogs[selectedIdx]) {
        const dialogId = list.postDialogs[selectedIdx].id;
        let filesId = [];

        // 새로 업로드된 파일이 있는 경우에만 파일 업로드 API 호출
        const newFiles = fileList.filter(
          (file) => 'name' in file && !('uploadFile' in file)
        ) as File[];
        if (newFiles.length > 0) {
          const files = await forwardingService.uploadFile(newFiles);
          filesId = files?.data?.attachments?.map((file: any) => file.id);
        }

        // 기존 파일들의 ID 추가
        const existingFileIds = fileList
          .filter((file) => 'uploadFile' in file)
          .map((file) => file.uploadFile.id);

        filesId = [...filesId, ...existingFileIds];

        await forwardingService.updateMessage(dialogId, filesId, content);
        await fetchData();
        setContent('');
        setFileList([]);
        setIsModalOpen(false);
      }
    } catch (error) {
      console.error('Failed to update message:', error);
    }
  };
  useEffect(() => {
    console.log(id);
    fetchData();
  }, []);
  const [fileList, setFileList] = useState<any[]>([]);
  const [mode, setMode] = useState<'edit' | 'create'>('create');
  const handleUploadChange = (e: any) => {
    if (e.target.files[0]) {
      setFileList([...fileList, e.target.files[0]]);
    }
  };

  const handleFileDelete = (fileName: string) => {
    setFileList(
      fileList.filter((file) => {
        if ('name' in file && !('uploadFile' in file)) {
          return file.name !== fileName;
        }
        return file.uploadFile.fileName !== fileName;
      })
    );
  };

  const [content, setContent] = useState('');
  const [selectedIdx, setSelectedIdx] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const editorRef = useRef<Editor>(null);

  useEffect(() => {
    if (mode === 'edit' && list?.postDialogs[selectedIdx]?.content) {
      setContent(list.postDialogs[selectedIdx].content);
      editorRef.current
        ?.getInstance()
        .setMarkdown(list.postDialogs[selectedIdx].content);
    } else if (mode === 'create') {
      setContent('');
      editorRef.current?.getInstance().setMarkdown('');
    }
  }, [mode, selectedIdx, list]);

  const onClose = () => {
    confirm({
      wrapClassName: 'modal-request-fee-confirm',
      title: '대화를 종료하시겠습니까?',
      content: (
        <>
          <p>
            확인을 클릭하면 해당 포워딩 업체와의 대화가 종료되며, 60일 이후 자동
            삭제됩니다
          </p>
          <br />
          <p>대화가 종료되면 60일후 대화 정보가 삭제됩니다.</p>
        </>
      ),
      icon: false,
      centered: true,
      okText: '확인',
      cancelText: '취소',
      async onOk() {
        await forwardingService.updateStatus(Number(id), {
          cancelStatus: 'SellerCancel'
        });
        fetchData();
      },
      onCancel() {}
    });
  };
  const onAccept = () => {
    confirm({
      wrapClassName: 'modal-request-fee-confirm',
      title: '선적 시작을 수락하시겠습니까?',
      content: `확인을 클릭하면 해당 포워딩 업체에서 선적을 시작합니다.`,
      icon: false,
      centered: true,
      okText: '확인',
      cancelText: '취소',
      async onOk() {
        await forwardingService.updateStatus(Number(id), {
          status: 'ShippingConfirm'
        });
        fetchData();
      },
      onCancel() {}
    });
  };
  const onFinish = () => {
    confirm({
      wrapClassName: 'modal-request-fee-confirm',
      title: '진행 완료하시겠습니까?',
      content: `확인을 클릭하면 진행 완료로 상태가 변경됩니다.`,
      icon: false,
      centered: true,
      okText: '확인',
      cancelText: '취소',
      async onOk() {
        await forwardingService.updateStatus(Number(id), {
          status: 'Complete'
        });
        fetchData();
      },
      onCancel() {}
    });
  };

  const onCancel = () => {
    confirm({
      wrapClassName: 'modal-request-fee-confirm',
      title: '진행 완료를 철회하시겠습니까?',
      content: `확인을 클릭하면 선적 도착으로 상태가 변경됩니다.`,
      icon: false,
      centered: true,
      okText: '확인',
      cancelText: '취소',
      async onOk() {
        await forwardingService.updateStatus(Number(id), {
          status: 'ShippingArrival'
        });
        fetchData();
      },
      onCancel() {}
    });
  };

  const handleDownload = (url: string, fileName: string) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const onUploadImage = async (blob: File, callback: any) => {
    const url = await forwardingService.uploadFile([blob]);
    callback(url.data.attachments[0].url, '');
    return false;
  };

  return (
    <div>
      <div
        style={{
          position: 'sticky',
          top: 63,
          backgroundColor: '#f0f2f5',
          zIndex: 100
        }}
      >
        <div
          style={{
            padding: '1rem',
            backgroundColor: 'white',
            marginBottom: 13
          }}
        >
          <Row>
            <Col flex={10} style={{ paddingTop: '5px' }}>
              {list?.forwarding?.name}
            </Col>
            <Col flex={0.1}>
              <Button
                disabled={list?.cancelStatus === 'CancelComplete'}
                onClick={() => {
                  setMode('create');
                  setIsModalOpen(true);
                }}
                style={{ borderRadius: 8 }}
              >
                메세지 전송
              </Button>
            </Col>
          </Row>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 36
          }}
        >
          {list?.cancelStatus === 'CancelComplete' && (
            <p
              style={{
                color: '#D98282',
                marginTop: 8,
                fontSize: 12,
                fontWeight: 500
              }}
            >
              대화가 종료되었습니다.
            </p>
          )}
          <div style={{ display: 'flex', gap: 8 }}>
            {renderCancelBtn()}
            {list?.cancelStatus !== 'CancelComplete' && renderProgressBtn()}
          </div>

          {list?.quotation && (
            <Typography.Text
              style={{
                background: 'rgb(43, 44, 81)',
                padding: '0.25rem 2rem',
                borderRadius: '1rem',
                color: 'white',
                marginLeft: '10px'
              }}
            >
              {statusMsg[list?.status as StatusType] || 'Inprogress'}
            </Typography.Text>
          )}
        </div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
        {list?.postDialogs?.map((data: any, idx: number) => (
          <div key={idx}>
            <ViewerBox
              isActive={data.canEdit}
              imgSrc={`/images/${
                data.writerType === 'Seller'
                  ? 'S'
                  : data.writerType === 'Admin'
                  ? 'B'
                  : 'F'
              }.png`}
              initialValue={data.content}
              name={
                data.writerType === 'Seller'
                  ? list.seller.companyName
                  : data.writerName
              }
              date={new Date(data.created_at)}
            />
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: 8
              }}
            >
              <div style={{ display: 'flex', gap: 12 }}>
                {data.dialogFiles.map((attachment: any, key: number) => (
                  <Button
                    key={key}
                    onClick={() =>
                      handleDownload(
                        attachment.uploadFile.url,
                        attachment.uploadFile.fileName
                      )
                    }
                    style={{
                      padding: '0px 12px',
                      height: 30,
                      fontSize: 12,
                      borderRadius: 8,
                      display: 'flex',
                      gap: 8,
                      alignItems: 'center'
                    }}
                  >
                    <span>{attachment.uploadFile.fileName}</span>
                    <DownloadIcon />
                  </Button>
                ))}
              </div>
              {data.canEdit && (
                <Button
                  disabled={list?.cancelStatus === 'CancelComplete'}
                  onClick={() => {
                    setSelectedIdx(idx);
                    setMode('edit');
                    setIsModalOpen(true);
                  }}
                  style={{
                    width: 80,
                    fontSize: 12,
                    fontWeight: 500,
                    borderRadius: 8
                  }}
                >
                  수정
                </Button>
              )}
            </div>
          </div>
        ))}
      </div>

      <Modal
        width={'auto'}
        closeIcon={<CloseOutlined />}
        onCancel={() => setIsModalOpen(false)}
        title="메세지 작성"
        className="forwarding-modal"
        visible={isModalOpen}
        footer={[
          <button
            disabled={!!!content}
            className="forwarding-btn"
            onClick={
              mode === 'edit'
                ? onUpdate
                : async () => {
                    let filesId = [];

                    // 새로 업로드된 파일이 있는 경우에만 파일 업로드 API 호출
                    const newFiles = fileList.filter(
                      (file) => 'name' in file && !('uploadFile' in file)
                    ) as File[];
                    if (newFiles.length > 0) {
                      const files = await forwardingService.uploadFile(
                        newFiles
                      );
                      filesId = files?.data?.attachments?.map(
                        (file: any) => file.id
                      );
                    }

                    // 기존 파일들의 ID 추가
                    const existingFileIds = fileList
                      .filter((file) => 'uploadFile' in file)
                      .map((file) => file.uploadFile.id);

                    filesId = [...filesId, ...existingFileIds];

                    await forwardingService.createForwardingMessage({
                      postId: Number(id),
                      content: content,
                      attachment: filesId
                    });
                    fetchData();
                    setIsModalOpen(false);
                  }
            }
          >
            {mode === 'edit' ? '저장' : '메세지 전송'}
          </button>
        ]}
        centered
      >
        <Editor
          initialEditType="wysiwyg"
          hooks={{
            addImageBlobHook: (blob, callback) =>
              onUploadImage(blob as File, callback)
          }}
          ref={editorRef}
          onChange={() => {
            const markdown =
              editorRef.current?.getInstance()?.getMarkdown() || '';
            setContent(markdown);
          }}
          hideModeSwitch={true}
        />
        <div className="file-wrap">
          <label htmlFor="file" className="file-btn">
            <span>파일</span>
            <PaperClipOutlined width={16} height={16} />
          </label>
          <input
            onChange={handleUploadChange}
            type="file"
            id="file"
            style={{ display: 'none' }}
          />
          <div style={{ display: 'flex', gap: 12, overflowX: 'auto' }}>
            {fileList.map((file, index) => (
              <Button className="file-name" key={index}>
                <span>
                  {'name' in file && !('uploadFile' in file)
                    ? file.name
                    : file.uploadFile.fileName}
                </span>
                <CloseOutlined
                  onClick={() =>
                    handleFileDelete(
                      'name' in file && !('uploadFile' in file)
                        ? file.name
                        : file.uploadFile.fileName
                    )
                  }
                />
              </Button>
            ))}
          </div>
        </div>
      </Modal>
    </div>
  );
};
export default MessageInfo;
